module.exports = __webpack_public_path__ + "img/24.be801315.jpg";